import React, { useEffect, useState } from "react";
import moment from "moment";
import { AgendamentoFolga } from "../../model/entities/AgendamentoFolga";
import agendamentoFolgaApi from "../../api/agendamentoFolgaApi";
import { useSnack } from "../../redux/snack/snackHooks";
import Info from "../../components/Generics/Info";
import Container from "../../components/Generics/Container";
import { Grid } from "@material-ui/core";

type Props = {
  id?: string | number;
};

const TooltipAgendaFolga: React.FC<Props> = (props) => {
  const { id } = props;

  const mostrarSnack = useSnack();
  const [agendamento, setAgendamento] = useState<AgendamentoFolga | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    buscarAgendamento();
  }, []);

  async function buscarAgendamento() {
    try {
      setLoading(true);
      if (id) {
        const res = await agendamentoFolgaApi.getById(Number(id));
        setAgendamento({ ...res });
      } else {
        const novoAgendamento: AgendamentoFolga = {
          titulo: "",
          id: 0,
          startDate: new Date(),
          endDate: new Date(),
          solicitacaoPessoal: {
            id: 0,
            dataHoraSolicitacao: new Date(),
            nomeMotorista: "",
            telefoneMotorista: "",
            numeroAcionado: "",
            placaVeiculo: "",
            origemMotorista: "",
            descricaoSolicitacao: "",
            emailDestinatario: "",
            emailDestinatarioCopia: "",
          },
        };
        setAgendamento({ ...novoAgendamento });
      }
      setLoading(false);
    } catch (erro: any) {
      console.log("erro ao buscar agendamento especifico", erro);
      mostrarSnack("Erro ao buscar dados do agendamento", "error");
    }
  }
  if (loading || !agendamento) {
    return null;
  }

  return (
    <Grid container spacing={1} style={{ padding: "10px" }}>
      <Grid item md={12} xs={12}>
        <Info
          label={"Motorista"}
          children={agendamento.solicitacaoPessoal.nomeMotorista}
        />
      </Grid>

      <Grid item md={6} xs={12}>
        <Info
          label={"Data Inicial Solicitacao"}
          children={moment(agendamento.startDate).format("DD/MM/YYYY")}
        />
      </Grid>

      <Grid item md={6} xs={12}>
        <Info
          label={"Data Final Solicitacao"}
          children={moment(agendamento.endDate).format("DD/MM/YYYY")}
        />
      </Grid>

      <Grid item md={8} xs={12}>
        <Info
          label={"Telefone do Motorista"}
          children={agendamento.solicitacaoPessoal.telefoneMotorista.replace(
            "whatsapp:+",
            ""
          )}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Info
          label={"Origem Motorista"}
          children={agendamento.solicitacaoPessoal.origemMotorista}
        />
      </Grid>

      <Grid item md={8} xs={12}>
        <Info
          label={"Data da Solicitação"}
          children={moment(
            agendamento.solicitacaoPessoal.dataHoraSolicitacao
          ).format("DD/MM/YYYY - HH:mm")}
        />
      </Grid>

      <Grid item md={4} xs={12}>
        <Info
          label={"Placa Veículo"}
          children={agendamento.solicitacaoPessoal.placaVeiculo}
        />
      </Grid>

      <Grid item md={12} xs={12}>
        <Info
          label={"Descrição Solicitação"}
          children={agendamento.solicitacaoPessoal.descricaoSolicitacao}
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <Info
          label={"E-mail enviado para"}
          children={
            <div
              style={{
                wordBreak: "break-word",
                whiteSpace: "normal",
              }}
            >
              {agendamento.solicitacaoPessoal.emailDestinatario}
            </div>
          }
        />
      </Grid>

      <Grid item md={6} xs={12}>
        <Info
          label={"E-mail enviado com cópia para"}
          children={
            agendamento.solicitacaoPessoal.emailDestinatarioCopia &&
            agendamento.solicitacaoPessoal.emailDestinatarioCopia
              .split(",")
              .map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {item.trim()}
                </div>
              ))
          }
        />
      </Grid>
    </Grid>
  );
};

export default TooltipAgendaFolga;
